// extracted by mini-css-extract-plugin
export default {"title":"text_title__C0ekK","subtitle":"text_subtitle__Pewt8","bigText":"text_bigText__LEPMy","normalText":"text_normalText__5LFXk","smallText":"text_smallText__njQdc"};